import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  FiCheck,
  FiExternalLink,
  FiInfo,
  FiLock,
  FiShield,
  FiUser,
} from "react-icons/fi";
import { FaLandmark } from "react-icons/fa";

import { REPORTING_PORTAL_URL } from "../../config/reporting";
import styles from "./ReportingChannel.module.css";

const ReportingChannel = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = `${t("reporting.title")} - The Records Hub S.A.`;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [i18n.language, t]);

  return (
    <main className={styles.mainContainer}>
      <div className={styles.titleStrip} />
      <section className={styles.reportingSection} aria-labelledby="reporting-title">
        <div className={styles.hero}>
          <div className={styles.heroCopy}>
            <p className={styles.eyebrow}>{t("reporting.eyebrow")}</p>
            <h1 id="reporting-title" className={styles.reportingTitle}>
              {t("reporting.title")}
            </h1>
            <p className={styles.reportingDescription}>
              {t("reporting.description")}
            </p>
            <div className={styles.actions}>
              <a
                className={styles.reportingButton}
                href={REPORTING_PORTAL_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>{t("reporting.button")}</span>
                <FiExternalLink aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className={styles.heroGraphic} aria-hidden="true">
            <span className={styles.orbit} />
            <span className={styles.orbitInner} />
            <FiShield className={styles.heroShield} />
            <FiLock className={styles.heroLock} />
          </div>
        </div>

        <div id="reporting-process" className={styles.featureGrid}>
          <article className={styles.featureCard}>
            <div className={styles.iconCircle}>
              <FiUser aria-hidden="true" />
            </div>
            <h2>{t("reporting.anonymousTitle")}</h2>
            <p>{t("reporting.anonymousDescription")}</p>
          </article>
          <article className={styles.featureCard}>
            <div className={styles.iconCircle}>
              <FiShield aria-hidden="true" />
              <FiCheck className={styles.checkIcon} aria-hidden="true" />
            </div>
            <h2>{t("reporting.confidentialTitle")}</h2>
            <p>{t("reporting.confidentialDescription")}</p>
          </article>
          <article className={styles.featureCard}>
            <div className={styles.iconCircle}>
              <FaLandmark aria-hidden="true" />
            </div>
            <h2>{t("reporting.independentTitle")}</h2>
            <p>{t("reporting.independentDescription")}</p>
          </article>
        </div>

        <aside className={styles.independentNote}>
          <div className={styles.noteIcon}>
            <FiInfo aria-hidden="true" />
          </div>
          <div>
            <h2>{t("reporting.separateTitle")}</h2>
            <p>{t("reporting.separatePortal")}</p>
          </div>
        </aside>
      </section>

      <section className={styles.voiceSection}>
        <div className={styles.voiceInner}>
          <div className={styles.voiceGraphic} aria-hidden="true">
            <FiShield />
            <FiCheck className={styles.voiceCheck} />
          </div>
          <div className={styles.voiceCopy}>
            <h2>{t("reporting.voiceTitle")}</h2>
            <p>{t("reporting.voiceDescription")}</p>
          </div>
        </div>
      </section>
      <div className={styles.titleStrip} aria-hidden="true" />
    </main>
  );
};

export default ReportingChannel;
